
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/desks/[zone]/[slug]",
      function () {
        return require("private-next-pages/desks/[zone]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/desks/[zone]/[slug]"])
      });
    }
  